import { useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { usePaycodesTable } from 'hooks/paycodes/usePaycodes';
import { ContextMenu } from './ContextMenu';

const Table = () => {
    const { t } = useTranslation();
    const { rows, loading, reloading, selectedRow, setSelectedRow, contextMenu, setContextMenu, selected, setSelected, columns, cleanSelected } = usePaycodesTable();

    useEffect(() => {
        reloading();
    }, [reloading]);

    return (
        <div
            style={{ width: '100%', height: '100%' }}
            onContextMenu={(event) => {
                event.preventDefault();
                setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
            }}
        >
            <DataGridPro
                sx={{
                    height: 'calc(100vh - 140px)',
                    cursor: 'default',
                    '& .MuiDataGrid-cell': { cursor: 'pointer' },
                }}
                columns={columns}
                rows={rows}
                showCellVerticalBorder
                showColumnVerticalBorder
                disableColumnMenu
                disableColumnSelector
                disableRowSelectionOnClick
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'name', sort: 'asc' }],
                    },
                }}
                headerFilters
                localeText={{
                    headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                    headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                    headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                    headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                    headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                    headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                    footerRowSelected: (count) =>
                        count > 1
                            ? t('general.table.footerFilters.footerRowSelected.>1', { count, countFormatted: count.toLocaleString() })
                            : t('general.table.footerFilters.footerRowSelected.=1', { count, countFormatted: count.toLocaleString() }),

                    footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                    MuiTablePagination: {
                        labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} of ${count === -1 ? `more than ${to}` : count}`,
                        labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),
                    },
                }}
                loading={loading}
                checkboxSelection
                pagination
                rowSelectionModel={selected}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    let row = rows.filter((row) => newRowSelectionModel.includes(row.id));
                    setSelected(newRowSelectionModel);
                    setSelectedRow(row);
                }}
                slotProps={{
                    cell: {
                        onContextMenu: (event) => {
                            event.preventDefault();
                        },
                    },
                }}
            />

            <ContextMenu contextMenu={contextMenu} setContextMenu={setContextMenu} selectedRow={selectedRow} reloading={reloading} rows={rows} cleanSelected={cleanSelected} />
        </div>
    );
};

export { Table };
